import { ReactNode } from "react";
import cn from "classnames";
import c from "../../../styles/container.module.scss";
import s from "../Video.module.scss";
import { InnerSpacingVariant } from "../../../lib/storyblok/types/shared";

type Props = {
  featured?: boolean;
  children: ReactNode;
  spacing: InnerSpacingVariant;
};

const Container = ({ featured, children, spacing }: Props) => (
  <div
    className={cn(c.xWide, s.container, { [s.featured]: featured }, s[spacing])}
  >
    {children}
  </div>
);

export default Container;
